module.exports = __webpack_public_path__ + "static/img/yingyong.dbf6593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/yingyong.png
// module id = 7itK
// module chunks = 5